import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { themeGet } from 'styled-system';
import { Heading } from 'roo-ui/components';
import TruncateText from 'components/TruncateText';
import { getProperty } from 'store/booking/bookingSelectors';
import { useDataLayer } from 'hooks/useDataLayer';

const PropertyPolicies = () => {
  const { roomInformation } = useSelector(getProperty);
  const { emitInteractionEvent } = useDataLayer();

  const onClickReadMoreCallback = () => {
    emitInteractionEvent({ type: 'Property Policies More Link', value: 'Read More Link Selected' });
  };

  return (
    <Fragment>
      <Heading.h3 fontSize="md" mb={4} data-testid="property_policies_title">
        Property policies
      </Heading.h3>
      <TruncateText
        text={roomInformation}
        isTruncated
        background={themeGet('colors.gradients.transparentToGrey')}
        modalTitle="Cancellation Policy"
        data-testid="property_policies_description"
        onClickReadMoreCallback={onClickReadMoreCallback}
      />
    </Fragment>
  );
};

export default PropertyPolicies;
